// extracted by mini-css-extract-plugin
export var cardIcon = "_5r-5";
export var cardIconUnframed = "_5r-9";
export var checkboxCard = "_5r-0";
export var checkboxCardSelected = "_5r-4";
export var disabled = "_5r-2";
export var interactive = "_5r-1";
export var outerBorder = "_5r-3";
export var spacerMedium = "_5r-8";
export var spacerSmall = "_5r-7";
export var spacerXsmall = "_5r-6";